<template>
  <v-app id="inspire" class="bodyPadding"> 
    <mo-header></mo-header>
    <v-content>
		<sales-head></sales-head>		
		<sales-list></sales-list>
    </v-content>
  </v-app>
</template>

<script>

	import SalesHead from './Header.vue';	
    import SalesList from './List.vue';

	export default {
		data () {
			return {
		
			}		
		},
		components: {
          SalesHead,			
          SalesList
		}
	}
</script>

<style scoped>
  /* @import '../../shared/assets/css/shared.css';*/
</style>